import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component
export default class isAuthTokensMixin extends Vue {
  @State isTokensExist: boolean;

  get isAuthTokens(): boolean {
    return !!this.isTokensExist;
  }
}



// WEBPACK FOOTER //
// ./src/mixins/isAuthTokens.ts